import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function InputLabel({ text, required }) {
  const styles = useStyles();

  return (
    <>
      <span className={styles.labelText}>{text}</span>
      {required && <span className={styles.asterisk}> *</span>}
    </>
  );
}

InputLabel.propTypes = {
  text: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

InputLabel.defaultProps = {
  required: false,
};

export default InputLabel;
